module.exports = __webpack_public_path__ + "img/mingyong19.834da202.png";